import React from "react";

export default function ContactMap({
  address = "100 N Tampa St, Tampa, FL 33602",
  zoom = 17,
}) {
  const src = `https://maps.google.com/maps?q=${encodeURIComponent(
    address
  )}&t=k&z=${zoom}&output=embed`;

  return (
    <iframe
      title={`Map of ${address}`}
      src={src}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      className="w-full h-[320px] md:h-[480px]"
    />
  );
}
